const USA = {
  isUSA() {
    return localStorageIsUsable && window.localStorage.countryCode == 'us';
  },

  metersToFeet(meter) {
    return Math.round(meter / 0.3048);
  },

  convertMetersInHomepage() {
    if (TRANSLATE.language != 'en') {
      return;
    }
    const replaceMeters = html => {
      return html.replace(
          new RegExp(`${GOAL.meters} ?m\\b`, 'g'), GOAL.feet + ' ft'
        ).replace(
          new RegExp(
            `${GOAL.meters}( ?((?!meters).)*)meters`, 'g'
          ),
          GOAL.feet + '$1 feet'
        )
    };
    const headline = document.querySelector('.headline__description');
    headline.innerHTML = replaceMeters(headline.innerHTML);

    document.querySelectorAll('.instructions__details-text').forEach(detail =>
      detail.innerHTML = replaceMeters(detail.innerHTML));
  }
};
export default USA;



// WEBPACK FOOTER //
// ./src/assets/javascripts/usa-helpers.js